import React, { useState } from "react"
import {
  PromptText,
  Label,
  SubmitButton,
  ContactSelectInput,
  SuccessMessage,
  FormWrapper,
} from "./style"
import { Form } from "../../UI/Form"
import { TextInput } from "../../UI/Form/TextInput"
import { Checkbox } from "../../UI/Form/Checkbox"
import gql from "graphql-tag"
import { useMutation } from "@apollo/react-hooks"
import { Grid, Row, Col } from "UI/Grid"
import { InternalTemplateContainer, LeftCol } from "../InternalTemplate/style"
import Breadcrumbs from "../../UI/Breadcrumbs/Breadcrumbs"
import { LocationModule } from "../../Project/LocationModule"

const CREATE_CONTACT_ENQUIRY = gql`
  mutation CreateContactEnquiry(
    $firstName: String!
    $lastName: String!
    $phone: String!
    $email: String!
    $company: String!
    $enquiryType: String!
    $message: String!
    $subscriptionPermission: String!
    
  ) {
    createContactEnquiry(
      input: {
        clientMutationId: "Generic contact"
        firstName: $firstName
        lastName: $lastName
        phone: $phone
        email: $email
        company: $company
        enquiryType: $enquiryType
        message: $message
        subscriptionPermission: $subscriptionPermission
      }
    ) {
      data
      success
    }
  }
`

const enquiryTypeOptions = [
  { value: "general", label: "General" },
  { value: "sales", label: "Sales" },
  { value: "distribution", label: "Distribution" },
]

const ContactPage = ({title, uri}) => {
  const [submitted, setSubmitted] = useState(false)
  const [createContactEnquiry] = useMutation(CREATE_CONTACT_ENQUIRY)

  const onSubmit = (values) => {
    setSubmitted(true)
    console.log("values:", values)
    console.log('values.subscriptionPermission[0]:', values.subscriptionPermission[0]);
    
    createContactEnquiry({
      variables: {
        firstName: values.firstName,
        lastName: values.lastName,
        phone: values.phone,
        email: values.email,
        company: values.company,
        message: values.message,
        enquiryType: values.enquiryType.value,
        subscriptionPermission: values.subscriptionPermission[0] || "No",
      },
    })
  }

  return (
    <InternalTemplateContainer>
      <Grid>
        <Row>
          <LeftCol xs={12} md={9}>
            <Breadcrumbs title={title} uri={uri} />
            <FormWrapper>
              {!submitted && (
                <PromptText>
                  Please fill out the form below to get in touch with us.
                </PromptText>
              )}

              {submitted && (
                <SuccessMessage>
                  Thanks for getting in contact. <br /> We'll be in touch soon.
                </SuccessMessage>
              )}

              {!submitted && (
                <Form onSubmit={onSubmit}>
                  <Label required>First name</Label>
                  <TextInput name="firstName" type="text" />
                  <Label required>Last name</Label>
                  <TextInput name="lastName" type="text" />
                  <Label>Phone</Label>
                  <TextInput name="phone" type="text" />
                  <Label required>Email</Label>
                  <TextInput name="email" type="email" />
                  <Label>Company</Label>
                  <TextInput name="company" type="text" />
                  <Label required>Enquiry type</Label>
                  <ContactSelectInput
                    options={enquiryTypeOptions}
                    name="enquiryType"
                    type="select"
                    placeholder="Please select"
                  />

                  <Label required>Message</Label>
                  <TextInput name="message" type="textarea" />
                  <Checkbox
                    name="subscriptionPermission"
                    value="Yes"
                    label="Yes, I’d like to receive news & updates from WGA."
                  />
                  <SubmitButton submit label="Submit Message" />
                </Form>
              )}
            </FormWrapper>
          </LeftCol>
          <Col xs={12} md={3}>
            <LocationModule />
          </Col>
        </Row>
      </Grid>
    </InternalTemplateContainer>
  )
}

export default ContactPage
